var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_vm._t("default"),_vm._l((_vm.listOfIcons),function(ico){return (_vm.annotation)?_c('div',{key:_vm.generateUID()+'ico-'+ico,staticClass:"iconSelector",class:_vm.size,on:{"click":function($event){return _vm.onSelect(ico)}}},[_c('w-icon',{attrs:{"size":_vm.size,"icon":ico}})],1):_vm._e()})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }